"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var Column = function Column() {
  return null;
};

var _default = Column;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/rc-table/lib/Column.js
// module id = 530
// module chunks = 0